<template>
	<div class="hd-moa-frame-protein-rna">
		<base-image-svg
			class="js-moa-frame-protein-rna"
			:source="require('!html-loader!../../assets/svgs/08-moa-frame-purple-rna-created.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-moa-frame-protein-rna {
		position: absolute;
		left: 0;
		bottom: 0;
		margin-left: 100px;
		@include box(100%);

		:deep() svg {
			position: absolute;
			left: 0;
			@include center-y();
			width: 100%;
			@include fade-out();

			#rtc_1 {
				transform: translateX(10%) translateY(10%);
			}
			#rtc_2 {
				transform: translateX(-10%) translateY(-10%);
			}
			#rtc_6 {
				transform: translateX(-10%) translateY(10%);
			}

			#rtc_1, #rtc_2, #rtc_3, #rtc_4, #rtc_5, #rtc_6,
			#New_RNA, .tween-rna-block {
				@include fade-out();
			}

			#Background_New_RNA {
				@include fade-out();
				@include animation-float();
			}

			#Template_RNA {
				@include fade-out();
			}
		}

		@include res-screen-portrait {
			margin-left: 0;
			:deep() svg {
				@include center();
				@include box(100%);
			}
		}

		// Animation 
		[data-state="animation-ready"] {
			:deep() svg {
				opacity: 1;

				#Template_RNA {
					@include transition-frame-fade-in();
					transition-delay: 0.15s;
				}
				#rtc_3, #rtc_4, #rtc_5, #rtc_1, #rtc_2, #rtc_6  {
					@include transition-frame-fade-in();
					transition-delay: 0.25s;
				}

				#New_RNA {
					opacity: 1;
				}

				.tween-rna-block {
					opacity: 1;

					&.tween-rna-block-1 { transition-delay: 0.25s;}
					&.tween-rna-block-2 { transition-delay: 0.5s; }
					&.tween-rna-block-3 { transition-delay: 0.75s; }
					&.tween-rna-block-4 { transition-delay: 1s; }
					&.tween-rna-block-5 { transition-delay: 1.25s; }
					&.tween-rna-block-6 { transition-delay: 1.5s; }
					&.tween-rna-block-7 { transition-delay: 1.75s; }
					&.tween-rna-block-8 { transition-delay: 2s; }
				}

				#Background_New_RNA {
					opacity: 1;
					transition-delay: 1.5s;
				}
			}
		}
	}
</style>